import { getEnv, isClient, isServer } from './env.service';

/**
 * lazyService - Creates a lazily initialized service instance
 * using a factory function.
 *
 * @param factory - A function that returns the service instance.
 * @returns A proxy that lazily initializes the service instance on first access.
 */
function lazyService<T extends object>(factory: () => T): T {
  let instance: T | null = null;
  return new Proxy({} as T, {
    get(_target, prop, receiver) {
      if (instance === null) {
        instance = factory();
      }
      return Reflect.get(instance, prop, receiver);
    },
    set(_target, prop, value, receiver) {
      if (instance === null) {
        instance = factory();
      }
      return Reflect.set(instance, prop, value, receiver);
    },
  });
}

/**
 * API Service Factory
 *
 * Provides a single point to access shared service helpers.
 */
class ApiServiceFactory {
  get environment() {
    return getEnv();
  }

  get isServer() {
    return isServer();
  }

  get isClient() {
    return isClient();
  }
}

export const apiServiceFactory = new ApiServiceFactory();

export { isServer, isClient, getEnv };
